<app-trip-type-tabs [(value)]="selectedTripType" *ngIf="pageType !== 'bookingSearch' && selectedTripType"
  (valueChange)="onTripTypeChange($event)">
</app-trip-type-tabs>

<form [formGroup]="tripSearchForm" class="form-content" [ngClass]="{
  'booking-search-layout': pageType === 'bookingSearch',
  'mobile-layout': isMobile && pageType === 'bookingSearch',
  'tablet-layout': isTablet && pageType === 'bookingSearch',
  'desktop-layout': isDesktop && pageType === 'bookingSearch'
}" (ngSubmit)="$event.preventDefault()">
  <!-- Common Fields for all trip types -->
  <div class="form-group" [ngClass]="{
    'booking-search-layout': pageType === 'bookingSearch',
    'mobile-layout': isMobile && pageType === 'bookingSearch',
    'tablet-layout': isTablet && pageType === 'bookingSearch',
    'desktop-layout': isDesktop && pageType === 'bookingSearch'
  }">
    <label for="cityId">City</label>
    <mat-form-field appearance="outline" class="form-field" [ngClass]="{
      'booking-search-layout': pageType === 'bookingSearch',
      'mobile-layout': isMobile && pageType === 'bookingSearch',
      'tablet-layout': isTablet && pageType === 'bookingSearch',
      'desktop-layout': isDesktop && pageType === 'bookingSearch'
    }">
      <mat-select formControlName="cityId" placeholder="Select City" id="cityId" (selectionChange)="onCityChange()">
        @for (city of cities; track city.cityId) {
        <mat-option [value]="city.cityId">
          {{ city.cityName }}
        </mat-option>
        }
      </mat-select>
      @if (hasFieldError('cityId')) {
      <mat-error>{{ getFieldError('cityId') }}</mat-error>
      }
    </mat-form-field>
  </div>

  <div class="form-group" [ngClass]="{'booking-search-layout': pageType === 'bookingSearch'}">
    <label for="selectPackageType">Select Package Type</label>
    <mat-form-field appearance="outline" class="form-field"
      [ngClass]="{'booking-search-layout': pageType === 'bookingSearch'}">
      <mat-select formControlName="selectPackageType" placeholder="Select Package Type" id="selectPackageType"
        (selectionChange)="onPackageTypeChange()">
        <mat-option value="0">All</mat-option>
        @for (type of packages; track type.packageForId) {
        <mat-option [value]="type.packageForId">
          {{ type.packageForName }}
        </mat-option>
        }
      </mat-select>
      @if (isFieldInvalid('selectPackageType')) {
      <mat-error>{{ getFieldError('selectPackageType') }}</mat-error>
      }
    </mat-form-field>
  </div>

  <div class="form-group" [ngClass]="{'booking-search-layout': pageType === 'bookingSearch'}">
    <label for="vehicleTypeId">Vehicle Type</label>
    <mat-form-field appearance="outline" class="form-field"
      [ngClass]="{'booking-search-layout': pageType === 'bookingSearch'}">
      <mat-select formControlName="vehicleTypeId" placeholder="Select Vehicle Type" id="vehicleTypeId"
        (selectionChange)="onVehicleTypeChange()">
        <mat-option value="0">All</mat-option>
        @for (vehicle of vehicleTypes; track vehicle.vehicleTypeId) {
        @if (vehicle.isActive) {
        <mat-option [value]="vehicle.vehicleTypeId">
          {{ vehicle.vehicleTypeName }}
        </mat-option>
        }
        }
      </mat-select>
      @if (hasFieldError('vehicleTypeId')) {
      <mat-error>{{ getFieldError('vehicleTypeId') }}</mat-error>
      }
    </mat-form-field>
  </div>

  <!-- Trip-specific Fields -->
  @if (selectedTripType === 'local') {
  <div class="form-row" [ngClass]="{'booking-search-layout': pageType === 'bookingSearch'}">
    <div class="form-group" [ngClass]="{'booking-search-layout': pageType === 'bookingSearch'}">
      <label for="startDate">Start Date</label>
      <mat-form-field appearance="outline" class="form-field"
        [ngClass]="{'booking-search-layout': pageType === 'bookingSearch'}">
        <input matInput [matDatepicker]="localDatePicker" formControlName="startDate" placeholder="Select Start Date"
          id="startDate">
        <mat-datepicker-toggle matSuffix [for]="localDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #localDatePicker></mat-datepicker>
        @if (hasFieldError('startDate')) {
        <mat-error>{{ getFieldError('startDate') }}</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="form-group">
      <label for="pickupTime">Pickup Time*</label>
      <mat-form-field appearance="outline" class="form-field">
        <input matInput formControlName="pickupTime" placeholder="HH:MM" id="pickupTime" type="time" step="900" >
        <mat-icon matSuffix>schedule</mat-icon>
        @if (hasFieldError('pickupTime')) {
        <mat-error>{{ getFieldError('pickupTime') }}</mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  }

  @if (selectedTripType === 'outstation') {
  <div class="form-row" [ngClass]="{'booking-search-layout': pageType === 'bookingSearch'}">
    <div class="form-group" [ngClass]="{'booking-search-layout': pageType === 'bookingSearch'}">
      <label for="startDate">Start Date</label>
      <mat-form-field appearance="outline" class="form-field"
        [ngClass]="{'booking-search-layout': pageType === 'bookingSearch'}">
        <input matInput [matDatepicker]="outstationStartDatePicker" formControlName="startDate"
          placeholder="Select Start Date" id="startDate">
        <mat-datepicker-toggle matSuffix [for]="outstationStartDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #outstationStartDatePicker></mat-datepicker>
        @if (hasFieldError('startDate')) {
        <mat-error>{{ getFieldError('startDate') }}</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="form-group">
      <label for="pickupTime">Pickup Time*</label>
      <mat-form-field appearance="outline" class="form-field">
        <input matInput formControlName="pickupTime" placeholder="HH:MM" id="pickupTime" type="time" step="900" >
        <mat-icon matSuffix>schedule</mat-icon>
        @if (isFieldInvalid('pickupTime')) {
        <mat-error>{{ getFieldError('pickupTime') }}</mat-error>
        }
      </mat-form-field>
    </div>
  </div>

  <div class="form-group" [ngClass]="{'booking-search-layout': pageType === 'bookingSearch'}">
    <label for="endDate">End Date</label>
    <mat-form-field appearance="outline" class="form-field"
      [ngClass]="{'booking-search-layout': pageType === 'bookingSearch'}">
      <input matInput [matDatepicker]="outstationEndDatePicker" formControlName="endDate" placeholder="Select End Date"
        id="endDate">
      <mat-datepicker-toggle matSuffix [for]="outstationEndDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #outstationEndDatePicker></mat-datepicker>
      @if (hasFieldError('endDate')) {
      <mat-error>{{ getFieldError('endDate') }}</mat-error>
      }
    </mat-form-field>
  </div>
  }

  @if (selectedTripType === 'airport') {
  <div class="form-row" [ngClass]="{'booking-search-layout': pageType === 'bookingSearch'}">
    <div class="form-group" [ngClass]="{'booking-search-layout': pageType === 'bookingSearch'}">
      <label for="startDate">Start Date</label>
      <mat-form-field appearance="outline" class="form-field"
        [ngClass]="{'booking-search-layout': pageType === 'bookingSearch'}">
        <input matInput [matDatepicker]="airportStartDatePicker" formControlName="startDate"
          placeholder="Select Start Date" id="startDate">
        <mat-datepicker-toggle matSuffix [for]="airportStartDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #airportStartDatePicker></mat-datepicker>
        @if (hasFieldError('startDate')) {
        <mat-error>{{ getFieldError('startDate') }}</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="form-group">
      <label for="pickupTime">Pickup Time*</label>
      <mat-form-field appearance="outline" class="form-field">
        <input matInput formControlName="pickupTime" placeholder="HH:MM" id="pickupTime" type="time" step="900" >
        <mat-icon matSuffix>schedule</mat-icon>
        @if (hasFieldError('pickupTime')) {
        <mat-error>{{ getFieldError('pickupTime') }}</mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  }

  <!-- Explore Cabs Button -->
  <div class="form-group" [ngClass]="{'booking-search-layout': pageType === 'bookingSearch'}">
    <button type="button" mat-raised-button color="primary" class="explore-cabs-btn"
      [ngClass]="{'booking-search-layout': pageType === 'bookingSearch'}" (click)="onSearch()">
      <span>Explore Cabs</span>
    </button>
  </div>
</form>